export default "__VITE_ASSET__4020a6e2__"